import { render, staticRenderFns } from "./EdgeIcon.vue?vue&type=template&id=4aab0fe4&scoped=true"
import script from "./EdgeIcon.vue?vue&type=script&lang=js"
export * from "./EdgeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab0fe4",
  null
  
)

export default component.exports